type ValidateEmailType = {
  email: string | undefined,
  confirmEmail?: string
};

export function validateEmail({ email, confirmEmail }: ValidateEmailType): string {
  if (!email) return 'not-valid';
  const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  if (email === confirmEmail) {
    return EMAIL_REGEXP.test(email) ? 'valid' : 'not-valid';
  } else {
    return EMAIL_REGEXP.test(email) ? 'valid' : 'not-valid';
  }
}

type ValidatePasswordType = {
  password: string,
};

export function validatePassword({ password }: ValidatePasswordType): string{
  const PASSWORD_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\/])(?=.{8,})/;
  return PASSWORD_REGEXP.test(password) ? 'valid' : 'not-valid';
}